import PropTypes from "prop-types";

export const featureFlags = PropTypes.objectOf(
  PropTypes.shape({
    fetching: PropTypes.bool,
    enabled: PropTypes.bool,
    error: PropTypes.string,
  })
);
